import { useDispatch } from 'react-redux'

import { change } from 'redux-form'

export function useGenericChangeFormValue(formName: string, field: string) {
  const dispatch = useDispatch()

  return (value: unknown) => dispatch(change(formName, field, value))
}
